<ion-app>
  <ion-split-pane contentId="main-content">
    @if(showMenu){
    <ion-menu class="custom-menu" contentId="main-content" type="overlay">
      <ion-header class="ion-no-border">
        <div class="menu-header">
          <div class="logo-section">
            <ion-icon name="briefcase" class="logo-icon"></ion-icon>
            <div class="header-text">
              <h2>SmartServe</h2>
              <p class="subtitle">Organize &amp; Track</p>
            </div>
          </div>
          @if(activePropertyName) {
            <div class="active-property-badge">
              <div class="property-info">
                <ion-icon name="business-outline"></ion-icon>
                <span>{{ activePropertyName }}</span>
              </div>
              @if(showExitButton) {
                <button class="exit-action-btn" (click)="exitProperty()" title="Exit Property">
                  <ion-icon name="exit-outline"></ion-icon>
                </button>
              }
            </div>
          }
        </div>
      </ion-header>

      <ion-content class="menu-content">
        <ion-list class="menu-list">
          <ion-menu-toggle auto-hide="false">

            <!-- Task Categories -->
            @if(perm.canAccessPanelModule('task-category')) {
              <ion-item routerLink="/dashboard/task-category" routerLinkActive="selected"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="grid-outline"></ion-icon></div>
                <ion-label>Task Categories</ion-label>
              </ion-item>
            }

            <!-- Task -->
            @if(perm.canAccessPanelModule('task')) {
              <ion-item routerLink="/dashboard/task" routerLinkActive="selected"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="checkbox-outline"></ion-icon></div>
                <ion-label>Task</ion-label>
              </ion-item>
            }

            @if(perm.canAccessPanelModule('organization')) {
            <ion-item routerLink="/dashboard/organization"
              [class.selected]="isActive(['/dashboard/organization', '/dashboard/add-organization'])" routerDirection="root"
              lines="none" class="menu-item">
              <div class="icon-wrapper" slot="start">
                <ion-icon name="business-outline"></ion-icon>
              </div>
              <ion-label>Organization</ion-label>
            </ion-item>
            }

            <!-- Checklist -->
            @if(perm.canAccessPanelModule('checklist-listing')) {
              <ion-item routerLink="/dashboard/checklist-listing"
                [class.selected]="isActive(['/dashboard/checklist-listing', '/dashboard/create-check-list'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="list-outline"></ion-icon></div>
                <ion-label>Checklist</ion-label>
              </ion-item>
            }

            <!-- Report -->
            @if(perm.canAccessPanelModule('report')) {
              <ion-item routerLink="/dashboard/report" routerLinkActive="selected"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="stats-chart-outline"></ion-icon></div>
                <ion-label>Report</ion-label>
              </ion-item>
            }

            <!-- User List -->
            @if(perm.canAccessPanelModule('user-list')) {
              <ion-item routerLink="/dashboard/user-list"
                [class.selected]="isActive(['/dashboard/user-list', '/dashboard/pending-approvals', '/dashboard/create-user'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="people-outline"></ion-icon></div>
                <ion-label>User List</ion-label>
              </ion-item>
            }

            <!-- Complaint Register -->
            @if(perm.canAccessPanelModule('complaint-register')) {
              <ion-item routerLink="/dashboard/complaint-list"
                [class.selected]="isActive(['/dashboard/complaint-list', '/dashboard/complaint-detail', '/dashboard/raise-complaint'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="ticket-outline"></ion-icon></div>
                <ion-label>Complaint Register</ion-label>
              </ion-item>
            }

            <!-- Complaint Report -->
            @if(perm.canAccessPanelModule('complaint-report')) {
              <ion-item routerLink="/dashboard/complaint-report"
                [class.selected]="isActive(['/dashboard/complaint-report','/dashboard/ticket-list'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="stats-chart-outline"></ion-icon></div>
                <ion-label>Complaint Report</ion-label>
              </ion-item>
            }

            <!-- Announcements -->
            @if(perm.canAccessPanelModule('announcements')) {
              <ion-item routerLink="/dashboard/announcement-list"
                [class.selected]="isActive(['/dashboard/announcement-list', '/dashboard/announcement-create'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="megaphone-outline"></ion-icon></div>
                <ion-label>Announcements</ion-label>
              </ion-item>
            }

            <!-- Roles (RBAC) -->
            @if(perm.canAccessPanelModule('roles')) {
              <ion-item routerLink="/dashboard/roles"
                [class.selected]="isActive(['/dashboard/roles', '/dashboard/role-form'])"
                routerDirection="root" lines="none" class="menu-item">
                <div class="icon-wrapper" slot="start"><ion-icon name="shield-checkmark-outline"></ion-icon></div>
                <ion-label>Roles</ion-label>
              </ion-item>
            }

          </ion-menu-toggle>
        </ion-list>
      </ion-content>

      <ion-footer class="ion-no-border">
        <div class="logout-section">
          <ion-button
            expand="block"
            (click)="confirmLogout()"
            type="button"
            class="logout-btn">
            <ion-icon name="log-out-outline" slot="start"></ion-icon>
            Logout
          </ion-button>
        </div>
      </ion-footer>
    </ion-menu>
    }
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <!-- Custom Confirm Modal Overlay -->
  <div class="custom-confirm-backdrop" *ngIf="showLogoutModal" (click)="cancelLogout()">
    <div class="custom-confirm-card" (click)="$event.stopPropagation()">
      <div class="modal-icon-wrap">
        <ion-icon name="log-out-outline"></ion-icon>
      </div>
      <h3>Confirm Logout</h3>
      <p>Are you sure you want to logout?</p>
      <div class="modal-buttons">
        <button class="btn-cancel" (click)="cancelLogout()">Cancel</button>
        <button class="btn-confirm" (click)="confirmLogoutAction()">Logout</button>
      </div>
    </div>
  </div>
</ion-app>